var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M8.49998 9.69C12.725 9.69 16.15 7.80624 16.15 5.4825C16.15 3.15876 12.725 1.275 8.49998 1.275C4.275 1.275 0.849976 3.15876 0.849976 5.4825C0.849976 7.80624 4.275 9.69 8.49998 9.69Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.976115 7.7775C1.6302 9.73599 4.74999 11.22 8.49998 11.22C12.25 11.22 15.3698 9.73599 16.0238 7.7775C16.1067 8.02558 16.15 8.28126 16.15 8.5425C16.15 10.8662 12.725 12.75 8.49998 12.75C4.275 12.75 0.849976 10.8662 0.849976 8.5425C0.849976 8.28126 0.893265 8.02558 0.976115 7.7775Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.976115 10.8375C1.6302 12.796 4.74999 14.28 8.49998 14.28C12.25 14.28 15.3698 12.796 16.0238 10.8375C16.1067 11.0856 16.15 11.3413 16.15 11.6025C16.15 13.9262 12.725 15.81 8.49998 15.81C4.275 15.81 0.849976 13.9262 0.849976 11.6025C0.849976 11.3413 0.893265 11.0856 0.976115 10.8375Z",
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame9);
export default __webpack_public_path__ + "static/media/Frame (9).28035ff59d033fdb0cd36459fa873d3d.svg";
export { ForwardRef as ReactComponent };